import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, withStyles } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';
import styles from './suggestion-card.style';
import ScoreBadge from '../score-badge/score-badge';

const SuggestionCard = ({ classes, resource, onAccept, onDismiss, loading }) => {
  if (!resource) return null;

  return (
    <Box padding={2} border={1} borderColor="grey.300" borderRadius={4} data-testid="suggestion-card">
      <Box display="flex" alignItems="center" flexWrap="wrap" className={classes.titleRow}>
        <Typography variant="body1">{resource.name}</Typography>
        {resource.score != null ? (
          <Box marginLeft={1}>
            <ScoreBadge score={resource.score} showLabel />
          </Box>
        ) : null}
      </Box>
      <Typography variant="caption" color="textSecondary">
        Course ID: {resource.id}
        {resource.externalId ? ` · External ID: ${resource.externalId}` : ''}
      </Typography>
      {resource.description ? (
        <Typography variant="body2" color="textSecondary" className={classes.description}>
          {resource.description}
        </Typography>
      ) : null}
      <Box display="flex" marginTop={2}>
        <Box marginRight={1}>
          <Button
            color="primary"
            variant="contained"
            size="small"
            disabled={loading}
            onClick={onAccept}
            data-testid="accept-suggestion-btn"
          >
            Accept suggestion
          </Button>
        </Box>
        <Button
          color="default"
          variant="outlined"
          size="small"
          disabled={loading}
          onClick={onDismiss}
          data-testid="dismiss-suggestion-btn"
        >
          Dismiss
        </Button>
      </Box>
    </Box>
  );
};

SuggestionCard.propTypes = {
  resource: PropTypes.object,
  onAccept: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

SuggestionCard.defaultProps = {
  resource: null,
  loading: false,
};

export default withStyles(styles)(SuggestionCard);
